import { ContentBlockImageData, EventType, FormDto, PageDto, TranslatableField } from '../../../models';
import { ContentBlockTextHorizontalAlignment } from '../ContentBlockModel';

export enum HeaderSectionLayout {
  Boxed = 'boxed',
  FullWidth = 'fullWidth',
  Lifted = 'lifted',
  Split = 'split',
}

export enum HeaderSectionImageHeight {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum HeaderSectionImageType {
  Boxed = 'boxed',
  FullWidth = 'fullWidth',
}

export enum HeaderSectionImageSide {
  Left = 'left',
  Right = 'right',
}

export interface HeaderSectionModel {
  image: ContentBlockImageData;
  opacity: number;
  layout: HeaderSectionLayout;
  textHorizontalAlignment: ContentBlockTextHorizontalAlignment;
  imageHeight: HeaderSectionImageHeight;
  imageType: HeaderSectionImageType;
  imageSide: HeaderSectionImageSide;
}

export interface WebsiteHeaderProps {
  headerSection: HeaderSectionModel;
  name: TranslatableField;
  startDate: string;
  endDate: string;
  type: EventType;
  place: TranslatableField;
  forms: FormDto[];
  registrationPage: PageDto | undefined;
  submissionPage: PageDto | undefined;
  readOnly?: boolean;
}

export const headerSectionLayoutImagesMap: Record<
  HeaderSectionLayout,
  {
    url: string;
    width: number;
    height: number;
  }
> = {
  [HeaderSectionLayout.Boxed]: {
    url: '/images/global_sections/header_boxed',
    width: 1564,
    height: 734,
  },
  [HeaderSectionLayout.FullWidth]: {
    url: '/images/global_sections/header_full-width',
    width: 1564,
    height: 734,
  },
  [HeaderSectionLayout.Lifted]: {
    url: '/images/global_sections/header_lifted',
    width: 1564,
    height: 734,
  },
  [HeaderSectionLayout.Split]: {
    url: '/images/global_sections/header_split',
    width: 1564,
    height: 734,
  },
};

export const headerSectionImageHeightModifiersMap: Record<HeaderSectionImageHeight, string> = {
  [HeaderSectionImageHeight.Small]: '-small',
  [HeaderSectionImageHeight.Medium]: '-medium',
  [HeaderSectionImageHeight.Large]: '-large',
};

export const isPremiumHeaderLayout = (layout: HeaderSectionLayout): boolean => {
  const basicLayouts = [HeaderSectionLayout.Boxed];

  return !basicLayouts.includes(layout);
};
